import { render } from "./table.vue?vue&type=template&id=08ffcade&scoped=true&lang=pug"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import "./table.vue?vue&type=style&index=0&id=08ffcade&lang=scss&scoped=true"
import "./table.vue?vue&type=style&index=1&id=08ffcade&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ffcade"]])

export default __exports__